declare const Experiment:{
	Experiment:AmplitudeExperiment
}

interface AmplitudeExperiment {
	initializeWithAmplitudeAnalytics( apiKey:string, options?:{ debug:boolean }):AmplitudeExperiment
	start(): Promise<void>
	variant( name:string ): Variant|null
	all():Variant[]
}


interface Variant {
	key:string,
	value?:string
}


declare const GLOBAL_AmplitudeAPIKey:string
declare const DEBUG_DebugMode:boolean|undefined

let DEBUG_debugMode:boolean = (typeof(DEBUG_DebugMode) !== 'undefined') && DEBUG_DebugMode


enum FeatureFlags {
	'UI_RegionPage::EnterAnimation' = 'ui_regionpage-enteranimation',
	'UI_RegionPage::ParallaxItems' = 'ui_regionpage-parallaxitems',
	'UI_RegionPage::ItemHighlighting' = 'ui_regionpage-itemhighlighting',
	'UI_RegionPage::PlaceRatings' = 'ui_regionpage-placeratings',
	'UI_RegionPage::PricingInfo' = 'ui_regionpage-pricinginfo',
	'UI_RegionPage::PrimaryCTAText' = 'ui_regionpage-primaryctatext',
	'UI_RegionPage::PrimaryCTAIcon' = 'ui_regionpage-primaryctaicon',
}

enum PrimaryCTAVariant {
	'Browse' = 'browse',
	'Explore'= 'explore',
	'Launch' = 'launch',
	'Open' = 'open',
}


export class Experiments {
	
	//
	// region state
	//
	
	private static experiment:AmplitudeExperiment
	
	// endregion
	
	
	//
	// region lifecycle
	//
	
	static async initialize( apiKey:string, debug:boolean = false ):Promise<void> {
		if( typeof Experiment === 'undefined' )
			throw new Error( 'Amplitude Experiment is not ready yet' )

		this.experiment = Experiment.Experiment.initializeWithAmplitudeAnalytics( apiKey, { debug: debug })

		await this.experiment.start()

		// show debug overlay if needed
		if( debug ){
			const variants:Variant[] = this.experiment.all()
			Object.keys( variants ).forEach(( key:string ) => {
				$( '#debug-overlay .variants' ).append( $( `
					<div class="d-flex justify-content-between">
						<span>${key}: </span>
						<span>${variants[key]?.value || '-' }</span>
					</div>` ))
			})
		}
	}
	
	// endregion
	

	//
	// region operations
	//

	public static isUIRegionPageEnterAnimationEnabled():boolean {
		return this.isTreatmentOn( FeatureFlags['UI_RegionPage::EnterAnimation'] )
	}
	
	
	public static isUI_RegionPageParallaxItemsEnabled():boolean {
		return this.isTreatmentOn( FeatureFlags['UI_RegionPage::ParallaxItems'] )
	}


	public static  isUI_RegionPageItemHighlightingEnabled():boolean {
		return this.isTreatmentOn( FeatureFlags['UI_RegionPage::ItemHighlighting'] )
	}
	
	
	public static isUI_RegionPagePlaceRatingsEnabled():boolean {
		return this.isTreatmentOn( FeatureFlags['UI_RegionPage::PlaceRatings'] )
	}


	public static isUI_RegionPagePricingInfoEnabled():boolean {
		return this.isTreatmentOn( FeatureFlags['UI_RegionPage::PricingInfo'] )
	}
	
	
	public static isUI_RegionPagePrimaryCTAIconEnabled() {
		return this.isTreatmentOn( FeatureFlags['UI_RegionPage::PrimaryCTAIcon'] )
	}
	
	
	public static getUI_RegionPagePrimaryCTAText():string {
		const value:PrimaryCTAVariant|null = this.getFeatureFlagValue( FeatureFlags['UI_RegionPage::PrimaryCTAText'] )
		if( value === null )
			return 'Browse'
		
		switch( value ){
		case PrimaryCTAVariant.Browse: return 'Browse'
		case PrimaryCTAVariant.Explore: return 'Explore'
		case PrimaryCTAVariant.Launch: return 'Launch'
		case PrimaryCTAVariant.Open: return 'Open'
		default: throw new Error( 'Unsupported value' )
		}
	}
	
	// endregion
	

	//
	// region helpers
	//

	private static getFeatureFlagValue( name:FeatureFlags ):any|null {
		if( this.experiment == null )
			throw new Error( 'Experiments are not initialized' )

		let variant:Variant|null = this.experiment.variant( name )
		if( variant == null )
			throw new Error( `Variant '${name}' not found` )
		
		if( variant?.key === 'off') 
			return null
		
		return variant.value || null
	}

	
	private static isTreatmentOn( name:FeatureFlags ):boolean {
		return this.getFeatureFlagValue( name ) === 'treatment'
	}
	
	// endregion
	
}

await Experiments.initialize( GLOBAL_AmplitudeAPIKey, DEBUG_debugMode )
export { }

